import { Separator } from '@/shared/components/shadcn/separator';

export function SettingPageHeader({ title }: { title: string }) {
  return (
    <div className="flex w-full flex-col">
      <p className="text-lg font-medium">{title}</p>
      <Separator className="my-6" />
    </div>
  );
}
